/* eslint-disable no-unused-vars */
import axios from 'axios';
import { overViewAPI } from '../../api/ENDPOINTS/overview';
import { vendorDashBoardAPI } from '../../api/ENDPOINTS/settings';
import { fetchData } from '../../api/GET/fetchData';
import http from '../../utils/http';

import {
    FETCH_SALES_OVERVIEW,
    GET_SALES_REPORT,
    REPORT_LOADING_STATE,
    SET_SALES_OVERVIEW_TYPE,
} from './reportsActionTypes';
// eslint-disable-next-line import/prefer-default-export
export function fetchSalesOverview() {
    // fetchSalesOverviewThunkFunction is the "thunk function"
    // its receives two arguments (dispatch, getState) methods
    return async function fetchSalesOverviewThunkFunction(dispatch) {
        dispatch({
            type: REPORT_LOADING_STATE,
            payload: true,
        });
        const response = await fetchData(overViewAPI);
        dispatch({
            type: FETCH_SALES_OVERVIEW,
            payload: response.data,
        });

        dispatch({
            type: REPORT_LOADING_STATE,
            payload: false,
        });
    };
}

export function setSalesOverviewType({ value, data }) {
    const total = {
        total_sales: data.reduce((r, item) => r + item.sales, 0),
        total_orders: data.reduce((r, item) => r + item.order, 0),
        total_earnings: data.reduce((r, item) => r + item.earnings, 0),
        total_items: data.reduce((r, item) => r + item.amt, 0),
    };
    return (dispatch) => {
        dispatch({
            type: SET_SALES_OVERVIEW_TYPE,
            payload: { value, total, data },
        });
    };
}

export function salesReport() {
    return async function salesReportDispatch(dispatch) {
        const response = await http
            .get(
                `${vendorDashBoardAPI}/sales?from=${'2021-01-01T04:47:45.531Z'}&to=${'2021-12-31T04:47:45.531Z'}`
            )
            .then((res) => res.data)
            .catch((err) => err);

        dispatch({
            type: GET_SALES_REPORT,
            payload: response,
        });
    };
}
